import { axiosRequest } from '@planbord/axios-request';
import { useMutation } from '@tanstack/vue-query';

export const useUpdateScheduleState = () => {
  const baseUrl = '/api';

  return useMutation({
    mutationFn: (value: { Id: number; ScheduleState: string | null }) =>
      axiosRequest
        .put(`${baseUrl}/updateScheduleState/${value.Id}`, value.ScheduleState)
        .then((res) => {
          return res.data;
        }),
  });
};
